import { defineMessages, useIntl } from '@redbubble/next/intl';

const messages = defineMessages({
  message0: {
    defaultMessage: 'Retro arcade carpet themed decor',
  },
  message1: {
    defaultMessage: 'Vintage kittens wearing bows stickers',
  },
  message2: {
    defaultMessage: 'Glamorous cowboy boots aesthetic posters',
  },
  message3: {
    defaultMessage: 'Pastel pixel gaming landscape totes',
  },
  message4: {
    defaultMessage: 'Dragons breathing fire phone cases',
  },
  message5: {
    defaultMessage: 'Anime girl eating ramen magnets',
  },
  message6: {
    defaultMessage: 'Cyber punk mechanical anatomy posters',
  },
  message7: {
    defaultMessage: 'Motivational quotes for athletes stickers',
  },
  message8: {
    defaultMessage: 'Vinyl record collector tshirts',
  },
  message9: {
    defaultMessage: 'Positive affirmations with aura gradient stickers',
  },
  message10: {
    defaultMessage: 'Romantasy for bookish nerds stickers',
  },
});

export const useEngageTextMessaging = (): string[] => {
  const intl = useIntl();

  return Object.keys(messages).map((key) => intl.formatMessage(messages[key]));
};
